<template>
  <div class="box">
    <admin-box-item title="상품일정">
      <admin-form-item label="상품일정">
        <!-- 캘린더 -->
        <template v-if="prod.id">
          <div v-if="dates.length>0" class="booking-calendar">
            <div class="grid-cal-title">
              <div>
                <button class="button button-now" @click="clickNow">오늘</button>
              </div>
              <!-- 연,월 -->
              <div class="flex flex-center justify-center">
                <div class="flex-align" style="gap:0 8px">
                  <i class="material-icons icon-arrow unselect" @click="clickPrev">keyboard_arrow_left</i>
                  <div class="size-18">{{ `${currentDate.year()}년 ${currentDate.month()+1}월` }}</div>
                  <i class="material-icons icon-arrow unselect" @click="clickNext">keyboard_arrow_right</i>
                </div>
              </div>
              <div class="flex-end">
                <button class="button is-primary button-set" @click="$emit('add')">+ 일정/가격 설정</button>
              </div>
            </div>
            <!-- 요일 -->
            <div class="lp-days">
              <div class="lp-day"
                   v-for="(day,idx) in days" :key="'day-'+idx">{{ day }}</div>
            </div>
            <!-- 일 -->
            <div class="lp-dates">
              <div class="lp-date unselect" :class="{'lp-date-before': date.before,
                                                      'lp-date-not': date.possible_resv === false}"
                   v-for="(date,idx) in dates" :key="'date-'+idx"
                   @click="clickDate(date)">
                <div class="day-num" :class="{'day-num-now': date.now}">{{date.day }}</div>
                <template v-if="date.possible_resv && !date.blank">
                  <div class="day-price">{{ date.sale_price|currency }}</div>
                  <div class="day-unit">{{ date.stock }}개</div>
                  <div class="flex" v-if="date.ordered_count && date.ordered_count>0">
                    <div class="day-ordered">예약 {{ date.ordered_count }}</div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>

        <!-- 저장되지 않은 상품의 경우 -->
        <block-negative v-else
                        :center="true"
                        notTxt="상품 시간 설정을 위해서 먼저 저장해주세요."
                        button="저장하기"
                        @clicked="$emit('save')"></block-negative>
      </admin-form-item>
    </admin-box-item>
    <modal-booking-date ref="dateModal" :prod="prod" :item="selectedDate"
                        @updatePrice="res => $emit('updatePrice', res)"
                        @accept="onAccept"></modal-booking-date>
  </div>
</template>

<script>
  import moment from 'moment'
  import ModalBookingDate from "./ModalBookingDate";
  import BlockNegative from "./BlockNegative";

  export default {
    name: 'PanelProductBooking',
    components: {BlockNegative, ModalBookingDate},
    props: {
      prod: {
        type: Object
      }
    },
    created() {
      this.now = moment();
      this.currentDate = moment();
      this.getDates();
    },
    data() {
      return {
        days: ['일','월','화','수','목','금','토'],
        dates: [],
        currentDate: '',
        selectedDate: undefined,
        now: ''
      }
    },
    methods: {
      clickNow() {
        this.currentDate = moment(this.now.format('YYYY-MM-DD'));
        this.getDates();
      },
      clickPrev() {
        this.currentDate.subtract(1, 'months');
        this.getDates();
      },
      clickNext() {
        this.currentDate.add(1, 'months');
        this.getDates();
      },
      getDates() {
        if(this.prod.id) {
          let year = this.currentDate.year();
          let month = this.currentDate.month()+1;
          this.$axios.get(this.getUrl(`booking/product/${this.prod.id}/calendar/${year}/${month}`)).then(res => {
            this.dates = res.data;
          });
        }
      },
      clickDate(date) {
        if(!date.before) {
          this.selectedDate = this.cloneItem(date);
          setTimeout(()=>{
            this.$refs.dateModal.open();
          }, 100);
        }
      },
      onAccept(item) {
        let index = this.dates.findIndex(i => i.date_str === this.selectedDate.date_str);
        this.dates[index] = item;
        this.$forceUpdate();
      }
    }
  }
</script>

<style lang="stylus" scoped>

  .booking-calendar
    margin-top 24px

  .grid-cal-title
    display grid
    grid-template-columns 120px 1fr 120px
    margin-bottom 12px
    align-items center

  .button-now
    width 76px
  .button-set
    width 132px

  .lp-days
    display grid
    grid-template-columns repeat(7, 1fr)
  .lp-day
    text-align center
    padding-bottom 4px
    color #4f4f4f
    height 40px
    line-height 40px

  .lp-dates
    display grid
    grid-template-columns repeat(7, 1fr)
    border-top 1px solid #dddddd
    border-left 1px solid #dddddd

  .lp-date
    width 100%
    height 100px
    border-right 1px solid #dddddd
    border-bottom 1px solid #dddddd
    padding 6px
    font-size 12px
  .lp-date-before
    background-color #F5F5F5
    color #989898 !important

  .lp-date-not
    background url(/office/static/icon/pattern.svg)
    background-position center
    background-size cover
    background-repeat no-repeat
    .day-num
      text-decoration line-through


  .day-num-now
    color white
    background-color #ff5722
    border-radius 100%
    width 16px
    height 16px
    line-height 16px
    text-align center

  .lp-date:hover
    // background #f5f5f5
    border 2px solid #363636

  .icon-arrow
    padding 0 8px
    height 22px

  .day-price
    margin-top 10px
    font-size 13px
  .day-unit
    font-size 12px
    color #787878
  .day-ordered
    margin-top 4px
    color white
    background-color #363636
    border-top-right-radius 20px
    border-bottom-right-radius 20px
    padding 2px 8px 2px 6px
    font-size 12px
    display flex
    align-items center
    height 18px

  .negative
    background-color #FFF0EB
    color #ff5722
    font-size 13px
    line-height 18.82px
    padding 12px 16px
    display flex
    gap 0 12px
    img
      margin-top 2px
      height 16px
  .not-txt
    flex 1
    white-space pre-line
    padding-right 8px
</style>
